import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface Result {
  deleteAppUser: string;
}

export const deleteAppUser = async <V>(
  apollo: DollarApollo<V>,
  appUserId: string
): Promise<FetchResult<Result>> => {
  const result = apollo.mutate({
    mutation: Mutation,
    variables: { appUserId }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
